import useYam from './bakery/useYam'
import useTokenBalance from './bakery/useTokenBalance'
import { useTokenBalance as useBNBbalance } from '../state/wallet/petHooks'

import { getBalanceNumber } from '../utils/bakery/formatBalance'
import { BigNumber } from '../sushi'

import {
    getSoccerAddress,
    getPokerAddress,
    getCarAddress,
    getDoggyAddress,
    getBarkAddress,
    getRacaAddress,
    getBusdAddress,
    getDogeAddress,
    getSushiAddress,
    getTokauAddress,
    getSfpAddress
} from '../sushi/utils'

const useBalanceByAddress = (address: string, decimals = 18) => {
    const balance = useTokenBalance(address)
    const balanceNum = getBalanceNumber(balance, decimals)
    const balanceFormat = new BigNumber(balanceNum).decimalPlaces(3, 1).toNumber()
    return balanceFormat
}

export function useBnbBalance(){
    const balance = useBNBbalance('wbnb')
    const balanceFormat = balance.decimalPlaces(3, 1).toNumber()
    return balanceFormat
}

export function useSoccerBalance(){
    const sushi = useYam()
    const address = getSoccerAddress(sushi)
    const balanceFormat = useBalanceByAddress(address)
    return balanceFormat
}

export function usePokerBalance(){
    const sushi = useYam()
    const address = getPokerAddress(sushi)
    const balanceFormat = useBalanceByAddress(address)
    return balanceFormat
}

export function useCarBalance(){
    const sushi = useYam()
    const address = getCarAddress(sushi)
    const balanceFormat = useBalanceByAddress(address)
    return balanceFormat
}

export function useDoggyBalance(){
    const sushi = useYam()
    const address = getDoggyAddress(sushi)
    const balanceFormat = useBalanceByAddress(address)
    return balanceFormat
}

export function useBarkBalance(){
  const sushi = useYam()
  const address = getBarkAddress(sushi)
  const balanceFormat = useBalanceByAddress(address)
  return balanceFormat
}

export function useRacaBalance(){
  const sushi = useYam()
  const address = getRacaAddress(sushi)
  const balanceFormat = useBalanceByAddress(address, 9)
  return balanceFormat
}

export function useBusdBalance(){
  const sushi = useYam()
  const address = getBusdAddress(sushi)
  const balanceFormat = useBalanceByAddress(address)
  return balanceFormat
}

export function useDogeBalance(){
  const sushi = useYam()
  const address = getDogeAddress(sushi)
  const balanceFormat = useBalanceByAddress(address, 8)
  return balanceFormat
}

export function useBakeBalance(){
  const sushi = useYam()
  const address = getSushiAddress(sushi)
  const balanceFormat = useBalanceByAddress(address)
  return balanceFormat
}

export function useTokauBalance(){
  const sushi = useYam()
  const address = getTokauAddress(sushi)
  const balanceFormat = useBalanceByAddress(address)
  return balanceFormat
}

export function useSfpBalance(){
  const sushi = useYam()
  const address = getSfpAddress(sushi)
  const balanceFormat = useBalanceByAddress(address)
  return balanceFormat
}
